import { ElementRef, Directive, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[msToHMS]',
})
export class MsToHMSDirective implements OnInit {
  @Input() public msToHMS!: number;
  constructor(private readonly _host: ElementRef) {}

  public ngOnInit() {
    const [hours, minutes, seconds] = parseMsToHMS(this.msToHMS);

    this._host.nativeElement.innerText = `${hours < 10 ? '0' + hours : hours}h${
      minutes < 10 ? '0' + minutes : minutes
    }m${seconds < 10 ? '0' + seconds : seconds}s`;
  }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function parseMsToHMS(ms: number) {
  // 1- Convert to seconds:
  let seconds = ms / 1000;
  // 2- Extract hours:
  const hours = Math.floor(Number(seconds / 3600)); // 3,600 seconds in 1 hour
  seconds = seconds % 3600; // seconds remaining after extracting hours
  // 3- Extract minutes:
  const minutes = Math.floor(Number(seconds / 60)); // 60 seconds in 1 minute
  // 4- Keep only seconds not extracted to minutes:
  seconds = Math.floor(seconds % 60);

  return [hours, minutes, seconds];
}
